import Cookies from "js-cookie";

export function setUtmCookies(utms: Record<string, string | undefined>) {
  Object.entries(utms).forEach(([key, value]) => {
    if (value) {
      Cookies.set(key, value, { expires: 90, path: "/" });
    }
  });
}

export type AttributionObject = {
  utm_campaign?: string;
  utm_content?: string;
  utm_medium?: string;
  utm_source?: string;
  utm_term?: string;
  fbclid?: string;
  gclid?: string;
  msclkid?: string;
  dclid?: string;
  raw_url?: string;
  url?: string;
  referer?: string;
  user_agent?: string;
  ip_address?: string;
};

export function getAttributionFromUrl(
  urlInput: string,
): Partial<AttributionObject> {
  try {
    const queryString = urlInput.includes("?")
      ? urlInput.split("?")[1]
      : urlInput;
    const urlParams = new URLSearchParams(queryString);
    const params: Partial<AttributionObject> = {};

    if (urlParams.has("utm_campaign")) {
      params.utm_campaign = decodeURIComponent(
        urlParams.get("utm_campaign") || "",
      );
    }
    if (urlParams.has("utm_content")) {
      params.utm_content = decodeURIComponent(
        urlParams.get("utm_content") || "",
      );
    }
    if (urlParams.has("utm_medium")) {
      params.utm_medium = decodeURIComponent(urlParams.get("utm_medium") || "");
    }
    if (urlParams.has("utm_source")) {
      params.utm_source = decodeURIComponent(urlParams.get("utm_source") || "");
    }
    if (urlParams.has("utm_term")) {
      params.utm_term = decodeURIComponent(urlParams.get("utm_term") || "");
    }
    if (urlParams.has("fbclid")) {
      params.fbclid = decodeURIComponent(urlParams.get("fbclid") || "");
    }
    if (urlParams.has("gclid")) {
      params.gclid = decodeURIComponent(urlParams.get("gclid") || "");
    }
    if (urlParams.has("msclkid")) {
      params.msclkid = decodeURIComponent(urlParams.get("msclkid") || "");
    }
    if (urlParams.has("dclid")) {
      params.dclid = decodeURIComponent(urlParams.get("dclid") || "");
    }
    return params;
  } catch (e) {
    console.error("Error parsing attribution from URL:", e);
    return {};
  }
}

export function getAttributionFromCookies(): Partial<AttributionObject> {
  return {
    utm_campaign: Cookies.get("utm_campaign") || undefined,
    utm_content: Cookies.get("utm_content") || undefined,
    utm_medium: Cookies.get("utm_medium") || undefined,
    utm_source: Cookies.get("utm_source") || undefined,
    utm_term: Cookies.get("utm_term") || undefined,
    fbclid: Cookies.get("fbclid") || undefined,
    gclid: Cookies.get("gclid") || undefined,
    msclkid: Cookies.get("msclkid") || undefined,
    dclid: Cookies.get("dclid") || undefined,
  };
}
